import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import type { CreateProductAutomationRequestDto } from "../../dtos/create-product-automation-request-dto";
import type { CreateProductAutomationResponseDto } from "../../dtos/create-product-automation-response-dto";
import { ProductService } from "../../services/product-service";

type UsePostCreateProductAutomationMutationParams = {
  options?: UseMutationOptions<
    CreateProductAutomationResponseDto,
    unknown,
    CreateProductAutomationRequestDto
  >;
};

export const usePostCreateProductAutomationMutation = ({
  options
}: UsePostCreateProductAutomationMutationParams = {}) => {
  return useMutation({
    mutationFn: async (payload) => {
      return await ProductService.createProductAutomation({ payload });
    },
    ...options
  });
};
